export const formFieldSize = {
    xsHeight: 'xs-height',
    sHeight: 's-height',
    mHeight: 'm-height',
    defHeight: 'def-height',
} as const;

export type TFormFieldSize = (typeof formFieldSize)[keyof typeof formFieldSize];
